import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-success-stories-details',
  templateUrl: './success-stories-details.component.html',
  styleUrls: ['./success-stories-details.component.scss']
})
export class SuccessStoriesDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
